import Enum from './enum'

/**
 * 強制停止フラグ
 */
class IsPending extends Enum {
    static PENDING = 1; // ログイン不可（ ←「停止中」から変更）
    static ACTIVE = 0; // ログイン可

    static values() {
        return {
            [this.PENDING]: 'ログイン不可', // ← 運営・学校画面で文言が違うとややこしいので「停止中」から変更
            [this.ACTIVE]: 'ログイン可',
        }
    }

    static valuesForSchool() {
        return {
            [this.PENDING]: 'ログイン不可',
            [this.ACTIVE]: 'ログイン可',
        }
    }

    static optionForSchool() {
        let object = this.valuesForSchool();
        let array = [];
        let keys = Object.keys(object);
        keys.forEach((key) => {
            array.push({
                key: key,
                label: object[key],
            });
        });

        return array;
    }
}

export default IsPending;
